module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_oslo_viken_pos.00b9d090.svg";